import React from "react";
import Input from "../../UI/Input/Input";
import Button from "../../UI/Button/Button";
import ContentForm from "../../UI/ContentForm/ContentForm";
import { updateObject, checkValidity } from "../../../shared/utility";
import "./KioskTypeForm.css";
import Fade from "react-reveal/Fade";
import FetchData from "../../../shared/fetchData";
import Select from "../../UI/Select/Select";
import LockerTypes from "./LockerTypes/LockerTypes";
import Remove from "@material-ui/icons/Remove";

const KioskTypeForm = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const [showLockerTypes, setShowLockerTypes] = React.useState(false);
  const [choosedLockerTypes, setChoosedLockerTypes] = React.useState(false);
  const [id, setId] = React.useState("");
  const [lockerTypes, setLockerTypes] = React.useState([]);
  const [lockerTypeList, setLockerTypeList] = React.useState([]);
  const [lockerType, setLockerType] = React.useState("");
  const [generations, setGenerations] = React.useState([]);
  const [generation, setGeneration] = React.useState("");
  const [invalidSelect, setInvalidSelect] = React.useState(false);
  const [kioskType, setKioskType] = React.useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
  });

  React.useEffect(() => {
    var grRaw = JSON.stringify({
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var grUrl = "management/api/v1/kiosktypes/getKioskGenerations";
    var raw = JSON.stringify({
      lockerType: {},
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/lockertypes/getLockerTypes";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          setLockerTypes(result.lockerTypes);
        }
      })
      .catch((error) => setLoading(false));

    FetchData(grRaw, grUrl)
      .then((response) => response.json())
      .then((grResult) => {
        setLoading(false);
        if (grResult.status == 0) {
          setGenerations(grResult.generations);
          if (props.edit == true) {
            const gnrtn = grResult.generations?.filter(
              (g) => g.generation === props.kioskType.generation
            );
            if (!!gnrtn && gnrtn.length > 0) {
              setGeneration({
                value: gnrtn[0].id,
                label: gnrtn[0].description,
              });
            }
            var raw = JSON.stringify({
              kioskLockerType: {
                kioskType: {
                  id: props.kioskType.id,
                },
              },
              pl: "10000",
              pn: "1",
              version: "mtpx001",
            });
            var url = "management/api/v1/kiosklockertypes/getKioskLockerTypes";
            FetchData(raw, url)
              .then((response) => response.json())
              .then((result) => {
                setLoading(false);
                if (result.status == 0) {
                  const lckTp = [];
                  result.kioskLockerTypes.map((l) => {
                    lckTp.push({
                      id: l.lockerType.id,
                      serial: l.serial,
                    });
                  });
                  setLockerTypeList(lckTp);
                }
              })
              .catch((error) => setLoading(false));
            const lckrTp = kioskType;
            lckrTp.description.value = props.kioskType.description;
            setKioskType(lckrTp);
            setEdit(true);
            setId(props.kioskType.id);
          }
        }
      })
      .catch((error) => setLoading(false));
  }, []);

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(kioskType, {
      [controlName]: updateObject(kioskType[controlName], {
        value: event.target.value,
      }),
    });
    setKioskType(updatedControls);
  };

  const kioskTypeSubmit = (event) => {
    let valid = true;
    const ltList = [];
    if (generation == "" || generation == null) {
      valid = false;
      setInvalidSelect(true);
    }
    for (let key in lockerTypeList) {
      ltList.push({
        id: lockerTypeList[key].id,
        serial: lockerTypeList[key].serial,
      });
    }
    const kt = kioskType;
    for (let key in kt) {
      if (kt[key].value == "") {
        kt[key].valid = false;
        valid = false;
      }
    }
    if (ltList == null || ltList.length == 0) {
      valid = false;
    }
    if (!valid) {
      setKioskType(kt);
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
    } else {
      if (!edit) {
        setLoading(true);
        const lckrTp = kioskType;
        var raw = JSON.stringify({
          kioskType: {
            lockerTypes: ltList,
            description: lckrTp.description.value,
            generation: generation?.value,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/kiosktypes/insertKioskType";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewKioskForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      } else {
        setLoading(true);
        const lckrTp = kioskType;
        var raw = JSON.stringify({
          kioskType: {
            id: id,
            lockerTypes: ltList,
            description: lckrTp.description.value,
            generation: generation?.value,
          },
          version: "mtpx001",
        });

        var url = "management/api/v1/kiosktypes/updateKioskType";
        FetchData(raw, url)
          .then((response) => response.json())
          .then((result) => {
            setLoading(false);
            if (result.status == 0) {
              props.toggleNewKioskForm(event, false);
            }
          })
          .catch((error) => setLoading(false));
      }
    }
  };

  const addLockerType = (event, lockerId) => {
    setLockerType(lockerId);
    if (changeForm) {
      setChangeForm(false);
    } else {
      setChangeForm(true);
    }
  };

  const addLockerTypeSubmit = (event, id) => {
    const serial = lockerTypeList.length;
    const ltList = lockerTypeList;
    ltList.push({ id: id, serial: serial + 1 });
    setLockerTypeList(ltList);
    if (changeForm) {
      setChangeForm(false);
    } else {
      setChangeForm(true);
    }
  };
  const removeLockerType = (event, lockerTp) => {
    const lckTps = lockerTypeList.filter((l) => l.serial != lockerTp.serial);
    for (let key in lckTps) {
      if (lckTps[key].serial > lockerTp.serial) {
        lckTps[key].serial = lckTps[key].serial - 1;
      }
    }
    setLockerTypeList(lckTps);
  };

  const changeShowLockerTypesForm = (event, value) => {
    if (value) {
      let valid = true;
      if (generation == "" || generation == null) {
        valid = false;
        setInvalidSelect(true);
      }
      const kt = kioskType;
      for (let key in kt) {
        if (kt[key].value == "") {
          kt[key].valid = false;
          valid = false;
        }
      }
      if (!valid) {
        setKioskType(kt);
        if (changeForm) {
          setChangeForm(false);
        } else {
          setChangeForm(true);
        }
      } else {
        setShowLockerTypes(value);
      }
    } else {
      setShowLockerTypes(value);
    }
  };

  const toggleShowSubmitForm = (event, value) => {
    setChoosedLockerTypes(value);
  };

  const formElementsArray = [];
  for (let key in kioskType) {
    formElementsArray.push({
      id: key,
      config: kioskType[key],
    });
  }

  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="6 mt-2"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  const changeGeneration = (selectedOption) => {
    setGeneration(selectedOption);
  };

  let lockerTList =
    lockerTypes != null && lockerTypes.length != 0
      ? lockerTypes.map((l) => {
          return (
            <LockerTypes
              addLockerTypeSubmit={addLockerTypeSubmit}
              current={lockerType}
              addLockerType={addLockerType}
              lockerTypeList={lockerTypeList}
              lockerType={l}
            />
          );
        })
      : "";
  let lckrTypes =
    lockerTypeList != null && lockerTypeList.length != 0
      ? lockerTypeList.map((l) => {
          const lt = lockerTypes.filter((lt) => lt.id == l.id);
          if (lt != null && lt.length != 0) {
            return (
              <div className="col-4 full-small">
                <div className="show-lckr-tp">
                  <div className="col-3">سریال:{l.serial}</div>
                  <div className="col-7">{lt[0].description}</div>
                  <div className="col-2">
                    <Remove
                      className="ksk-lck-tp-icon"
                      onClick={(event) => removeLockerType(event, l)}
                    />
                  </div>
                </div>
              </div>
            );
          }
        })
      : "";
  let lckrTypesShow =
    lockerTypeList != null && lockerTypeList.length != 0
      ? lockerTypeList.map((l) => {
          const lt = lockerTypes.filter((lt) => lt.id == l.id);
          if (lt != null && lt.length != 0) {
            return (
              <div className="col-12">
                <div className="show-lckr-tp">
                  <div className="col-4">سریال:{l.serial}</div>
                  <div className="col-8">{lt[0].description}</div>
                </div>
              </div>
            );
          }
        })
      : "";

  const kioskInfo = choosedLockerTypes ? (
    <div className="col-12">
      <div className="ksk-tp-info">
        <div>{kioskType.description.value}</div>
      </div>
    </div>
  ) : (
    ""
  );
  let generationList = [];
  if (generations != null && generations.length != 0) {
    generations.map((k) => {
      generationList.push({
        value: k.generation,
        label: k.description,
      });
    });
  }
  return (
    <div>
      {!showLockerTypes ? (
        <Fade duration={200} left cascade>
          <div>
            <div className="row justify-content-center">
              <div className="ksk-tp-cntnr">
                <ContentForm headetText="نوع لاکر">
                  <div className="ksk-tp-frm">
                    {form}
                    <Select
                      name="form-field-name"
                      value={generation}
                      placeholder="نسل لاکر"
                      options={generationList}
                      onChange={changeGeneration}
                      col="6 mt-2"
                      className={
                        invalidSelect &&
                        (!generation == null || generation == "")
                          ? "invalid-select"
                          : ""
                      }
                    />
                  </div>
                  <div className="col-12">
                    <div className="row justify-content-center w-100 mt-3">
                      <div className="col-6 text-center">
                        <Button
                          btnType="General"
                          clicked={(event) =>
                            props.toggleNewKioskForm(event, false)
                          }
                        >
                          برگشت
                        </Button>
                      </div>
                      <div className="col-6 text-center">
                        <Button
                          btnType="Success"
                          clicked={(event) =>
                            changeShowLockerTypesForm(event, true)
                          }
                        >
                          بعدی
                        </Button>
                      </div>
                    </div>
                  </div>
                </ContentForm>
              </div>
            </div>
          </div>
        </Fade>
      ) : (
        <Fade duration={200} left cascade>
          <div>
            {!choosedLockerTypes ? (
              <div className="row justify-content-center">
                <div className="ksk-tp-cntnr">
                  <ContentForm headetText="انتخاب نوع باکس">
                    <div className="ksk-tp-frm">
                      {lckrTypes}
                      {lockerTList}
                    </div>
                    <div className="col-12">
                      {lockerTypeList != null && lockerTypeList.length > 0 ? (
                        <div className="row justify-content-center mt-3">
                          <div className="col-6">
                            <Button
                              btnType="General"
                              clicked={(event) =>
                                changeShowLockerTypesForm(event, false)
                              }
                            >
                              برگشت
                            </Button>
                          </div>
                          <div className="col-6 text-left">
                            <Button
                              btnType="Success"
                              clicked={(event) =>
                                toggleShowSubmitForm(event, true)
                              }
                            >
                              بعدی
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="row justify-content-center mt-3">
                          <div className="col-12 text-center">
                            <Button
                              btnType="General"
                              clicked={(event) =>
                                changeShowLockerTypesForm(event, false)
                              }
                            >
                              برگشت
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </ContentForm>
                </div>
              </div>
            ) : (
              <div className="row justify-content-center">
                <div className="ksk-tp-cntnr">
                  <ContentForm headetText="انتخاب نوع باکس">
                    <div className="ksk-tp-frm">
                      {kioskInfo}
                      {lckrTypesShow}
                    </div>
                    <div className="row justify-content-center w-100 mt-3">
                      <div className="col-3 text-right hulf-small">
                        <Button
                          btnType="General"
                          clicked={(event) =>
                            toggleShowSubmitForm(event, false)
                          }
                        >
                          برگشت
                        </Button>
                      </div>
                      <div className="col-3 text-left hulf-small">
                        <Button btnType="Success" clicked={kioskTypeSubmit}>
                          ثبت
                        </Button>
                      </div>
                    </div>
                  </ContentForm>
                </div>
              </div>
            )}
          </div>
        </Fade>
      )}
    </div>
  );
};

export default KioskTypeForm;
